var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffcanvasBackgroundLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1075,
    height: 4189,
    viewBox: "0 0 1075 4189",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 28.5C168 173.5 779 106.5 974 0.5M1 142.5C231 35.5 433.5 21.8279 548.5 58C746 120.122 900 226 998 161.5M821 0.5L1014 496M759 0.5C364.5 950.5 1159.5 2765.5 636.5 3968M998 1547.5C325.5 689 866.706 312.053 998 196M998 327C735.5 669.5 904 2529.5 1074 4188M1014 983.5C496.701 555.733 796 209 522.758 80.5C472.928 57.0664 409.5 64 364 0.5M644.924 766C814.613 484.347 931.804 530.981 994.5 639.051"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffcanvasBackgroundLines);
export default __webpack_public_path__ + "static/media/offcanvas-background-lines.93269bb49b320b352ea594b5ae787d01.svg";
export { ForwardRef as ReactComponent };